import React from 'react';
import { MdConnectingAirports } from "react-icons/md";
import { Spacing } from "_styles";

const ConnectionBanner = ({ connectionFlight, isOnwards }) => {
    if (!connectionFlight) return null;

    const flight = connectionFlight.carrierCode && connectionFlight.flightNumber
        ? `${connectionFlight.carrierCode}${connectionFlight.flightNumber}`
        : '';

    const route = isOnwards
        ? `${connectionFlight?.origin} → ${connectionFlight?.destination}`
        : `from ${connectionFlight?.origin}`;

    const time = connectionFlight?.scheduledDepartureTime
        ? new Date(connectionFlight.scheduledDepartureTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : null;

    const gateStand = [
        connectionFlight?.gate && `Gate ${connectionFlight.gate}`,
        connectionFlight?.stand && `Stand ${connectionFlight.stand}`,
    ].filter(Boolean).join(' / ');

    return (
        <div style={{ backgroundColor: '#FFF3E0', borderRadius: 10, padding: Spacing.SCALE_18, marginTop: Spacing.SCALE_10 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: Spacing.SCALE_8, color: '#E65100' }}>
                <MdConnectingAirports size={Spacing.SCALE_28} color="#E65100" />
                <div>
                    <p style={{ margin: 0, fontWeight: 600 }}>
                        {isOnwards ? `Connection — ${flight} ${route}` : `Connection — Inbound ${flight} ${route}`}
                    </p>
                    {(time || gateStand) && (
                        <p style={{ margin: 0, fontSize: 13, opacity: 0.85 }}>
                            {[time, gateStand].filter(Boolean).join(' · ')}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default React.memo(ConnectionBanner);
